import { Injectable, signal, effect } from '@angular/core';
import { switchMap, timer } from "rxjs";
import {PollingParams} from "../types/polling.types";


@Injectable({
  providedIn: 'root'
})
export class PollingService {
  private activePolling = signal<{ stop: () => void } | null>(null);

  constructor() {
    effect((onCleanup) => {
      const polling = this.activePolling();
      onCleanup(() => polling?.stop());
    }, { allowSignalWrites: true });
  }

  public startPolling<T>({ intervalMs, requestFn, callback }: PollingParams<T>): void {
    this.stopPolling();

    const abortController = new AbortController();
    const { signal } = abortController;

    const sub = timer(0, intervalMs)
      .pipe(
        switchMap(() => requestFn())
      )
      .subscribe({
        next: (data) => {
          if (!signal.aborted) {
            callback(data);
          }
        },
        error: (err) => {
          if (!signal.aborted) {
            console.error('Polling error:', err);
          }
        }
      });

    this.activePolling.set({
      stop: () => {
        abortController.abort();
        sub.unsubscribe();
      }
    });
  }

  public stopPolling(): void {
    this.activePolling()?.stop();
    this.activePolling.set(null);
  }
}
